import {
  searchTerminal,
  addTerminal,
  getTerminalModels,
  fetchRestaurants,
  searchDrain,
  getRealtimeTerminalInfo
} from '../api'

import {
  INIT_TERMINAL_LIST,
  SET_TERMINAL_MODELS,
  SET_TERMINAL_IMEI,
  SET_DAILY_DRAIN_LIST,
  SET_REALTIME_INFO,
  SET_DRAIN_COUNT,
  SET_WS
} from './mutation_types'


const state = {
  terminalList: [],
  total: 0,
  terminalModels: [],
  restaurants: [],
  drainList: null,
  drainCount: 0,
  realtimeInfo: null,
  ws: null
}

const getters = {
  terminalModels: state => state.terminalModels
}

const actions = {
  initTerminalList({ commit }, reqParam) {
    searchTerminal(reqParam).then(res => {
      commit(INIT_TERMINAL_LIST, res.data)
    })
  },
  addTerminal({ commit }, { reqParams, cb, errorCb }) {
    addTerminal(reqParams).then(res => {
      const { success, msg } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }

      cb && cb()
    })
  },
  getTerminalModels({ commit }, callback) {
    getTerminalModels().then(res => {
      commit(SET_TERMINAL_MODELS, res.data.data_collect)
      callback && callback()
    })
  },
  getRestaurantOptions({ commit }) {
    fetchRestaurants().then(res => {
      commit(SET_TERMINAL_IMEI, res.data.data_collect)
    })
  },
  searchDrain({ commit }, { reqParam, cb, errorCb }) {
    searchDrain(reqParam).then(res => {
      const { success, msg, data_collect: data, data_count: count } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }

      let list = Object.keys(data).sort((pre, cur) => {
        const makeTimeStamp = date => new Date(date.replace('-', '/')).getTime()
        let preTimeStamp = makeTimeStamp(pre)
        let curTimeStamp = makeTimeStamp(cur)
        return curTimeStamp - preTimeStamp
      }).reduce((pre, cur) => {
        pre[cur] = data[cur]
        return pre
      }, {})

      commit(SET_DAILY_DRAIN_LIST, list)
      commit(SET_DRAIN_COUNT, count)
      cb && cb()
    })
  },
  getRealtimeTerminalInfo({ commit }, imei) {
    const ws = getRealtimeTerminalInfo(imei)

    commit(SET_WS, ws)

    ws.addEventListener('message', ({ data }) => {
      var info = JSON.parse(data)
      var time = info.power_time || 0
      var runTime = ''

      if (time !== null && time !== '') {
        if (time > 60 && time < 60 * 60) {
          runTime = parseInt(time / 60.0) + '分钟'
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          runTime = parseInt(time / 3600.0) + '小时' + parseInt((parseFloat(time / 3600.0) -
            parseInt(time / 3600.0)) * 60) + '分钟'
        } else if (time >= 60 * 60 * 24) {
          runTime = parseInt(time / 3600.0 / 24) + '天' + parseInt((parseFloat(time / 3600.0 / 24) -
            parseInt(time / 3600.0 / 24)) * 24) + '小时' + parseInt((parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) * 60) + '分钟'
        } else {
          runTime = parseInt(time) + '秒'
        }
      }

      commit(SET_REALTIME_INFO, Object.assign({}, info, { run_time: runTime }))
    })
  }
}

const mutations = {
  [INIT_TERMINAL_LIST](state, data) {
    state.terminalList = data.data_collect || []
    state.total = data.data_count
  },
  [SET_TERMINAL_MODELS](state, models) {
    state.terminalModels = models
  },
  [SET_TERMINAL_IMEI](state, imei) {
    state.restaurants = imei
  },
  [SET_DAILY_DRAIN_LIST](state, list) {
    state.drainList = list
  },
  [SET_DRAIN_COUNT](state, count) {
    state.drainCount = count
  },
  [SET_REALTIME_INFO](state, info) {
    state.realtimeInfo = info
  },
  [SET_WS](state, ws) {
    state.ws = ws
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/terminalManage.js